import { Box, IconButton, Image, Tooltip, Transition } from '@wix/design-system';
import { Maximize } from '@wix/wix-ui-icons-common';
import React from 'react';
import { wdsThemeColors } from '../../../../../utils/wds-theme-colors';
import { resolveImageUrl } from '../../utils/image-utils';
export const AltTextImageThumbnail = _ref => {
  let {
    imageUrl,
    imageSize = 32
  } = _ref;
  const thumbnailUrl = resolveImageUrl(imageUrl, imageSize, imageSize);
  return /*#__PURE__*/React.createElement(Image, {
    borderRadius: "4px" // TODO: consider replacing px with SP token
    ,
    dataHook: "alt-text-item-header-image",
    fit: "fill",
    height: imageSize,
    src: thumbnailUrl,
    width: imageSize
  });
};
export const AltTextImageThumbnailWithEnlarge = _ref2 => {
  let {
    imageUrl,
    imageSize = 32,
    isImageEnlarged = false,
    enlargeButtonTooltip,
    onEnlargeClick
  } = _ref2;
  return /*#__PURE__*/React.createElement(Transition, {
    dataHook: "alt-text-item-header-image-transition",
    enterAnimation: {
      fadeIn: {
        delay: 'long',
        duration: 'fast02',
        easing: 'enterEasing'
      }
    },
    exitAnimation: {
      fadeOut: {
        duration: 'fast02',
        easing: 'exitEasing'
      }
    },
    show: !isImageEnlarged
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "3px",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(AltTextImageThumbnail, {
    imageSize: imageSize,
    imageUrl: imageUrl
  }), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Tooltip, {
    content: enlargeButtonTooltip,
    size: "small"
  }, /*#__PURE__*/React.createElement(Box, {
    paddingBottom: "2px",
    paddingTop: "2px"
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": enlargeButtonTooltip,
    dataHook: "alt-text-item-header-enlarge-button",
    priority: "secondary",
    size: "small",
    skin: "light",
    onClick: e => {
      e.stopPropagation();
      onEnlargeClick == null || onEnlargeClick();
    }
  }, /*#__PURE__*/React.createElement(Maximize, {
    color: wdsThemeColors.iconPrimary
  })))))));
};
//# sourceMappingURL=alt-text-image-thumbnail.js.map